module.exports = __webpack_public_path__ + "static/media/ScoreSideBySide.42636b6f.png";